module.exports = __webpack_public_path__ + "static/media/44480962_2199904786751367_2313467551121670144_o-thumb.7ddaf287.jpg";